import React, { useEffect } from 'react';
import { Box, Typography, Breadcrumbs, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ServiceCard from '../components/ServiceCard';
import CourseCard from '../components/CourseCard';
import Header from '../components/Header';
import { theme } from '../Template';
import { Link , useParams } from 'react-router-dom';
import { useCompanyData } from '../../shared/contexts/DataContext';
import useCategoryList from '../../shared/logic/useCategoryList';
import useMyPagination from '../../shared/logic/useMyPagination';
import {SectionTitle} from '../components/SectionTitle';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import MyPagination from '../../shared/components/MyPagination';
import { categoryImage } from '../../shared/logic/imagesFns';
import GetImageDimensions from '../../shared/logic/getImgDimensions';
import { createMarkup, extractContent } from '../../shared/logic/Utils';

const useStyles = makeStyles((theme) => ({
  breadWhite:{
    color:'#fff',
    fontSize:'1.3rem'
  },

  showBtn:{
    color: '#0F467A',
    fontSize: '13px',
    marginLeft: '8px',
    cursor:'pointer',
    fontFamily:"'Cairo', sans-serif",
  },

  tp:{
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    fontFamily:"'Cairo', sans-serif"
  },

  descDiv:{
    alignSelf: 'center',
    outline: 'none',
    border: 'none',
    width: '100%',
    margin: '10px 0px',
    fontSize: '16px',
    color:'#000',
    fontFamily: "'Poppins', sans-serif",
    borderRadius: '8px',
    boxSizing:"border-box"
  },

  aboutImg:{
    boxShadow: '0px 0px 30px rgb(209,209,209)',
    "-webkit-box-shadow": '0px 0px 30px rgb(209,209,209)',
    "-moz-box-shadow": '0px 0px 30px rgb(209,209,209)'
  }
}));

const CategoriesList = () => {
  const { data } = useCompanyData();
  const { services, courses, categoryName, categoryCover, description } = useCategoryList();
  const { t, companyDomain, displayBanner=true } = data;
  const { id } = useParams();
  const classes = useStyles();

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <div>

      <Header image={categoryImage(categoryCover,data)} 
        data={data}
        height="400px"
        title={categoryName}
        transparencyColor={'#15476db2'}
        bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
        displayBanner={displayBanner}
        titleColor={'#ffffff'}
      >
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily:data?.fontFamily}} classes={{separator:classes.breadWhite,li:classes.breadWhite}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
            {t && t('companyPage.home')}
          </Link>
          <Typography style={{color:'#17c799',fontSize:'1.2rem'}}>{t && t('companyPage.category')}</Typography>
        </Breadcrumbs>
      </Header>

      <About 
        name={categoryName}
        image={categoryCover}
        description={description}
        t={t}
        data={data}
      />

      <Box width="90%" margin="auto" bgcolor="rgb(250, 250, 250)">
        <SectionTitle>Services</SectionTitle>
      </Box>      
      <ServicesList categories={services} data={data}  />
      {courses?.length ?
        <>
          <Box width="90%" margin="auto" bgcolor="rgb(250, 250, 250)">
            <SectionTitle>Courses</SectionTitle>
          </Box>
          <ServicesList categories={courses} data={data} course={true} />
        </>
      :
      null}
    </div>
  );
};

const About = ({ name, image, description, t, data }) => {
  const [imageDimensions, setImageDimensions] = React.useState({});
  const [showLess, setShowLess] = React.useState(true);
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const textLength = 200;
  const classes = useStyles();
  const desc = description || '';
  const extractedDesc = extractContent(desc);

  const { buttonFontColor, isRTL } = data || {};

  React.useEffect(() => {
    GetImageDimensions(setImageDimensions, image);
  }, [image]);

    return (
      <Box
        py={5}
        width="95%"
        m="auto"
        display="flex"
        flexWrap="wrap"
        alignItems="center"
        justifyContent={{ xs: 'center', lg: 'space-around' }}
        style={{margin:'100px auto'}}
      >
        <Box width={{ xs: '100%', lg: '50%' }} pb={2}>
          <Box pb={3}>
            {/* <SectionSubtitle style={{fontFamily:data?.fontFamily}}>{t && t('companyPage.aboutus')}</SectionSubtitle> */}
            <SectionTitle>{name}</SectionTitle>
          </Box>
            <div className={classes.descDiv}>
                {/* <span className={classes.tp} style={{fontFamily:data?.fontFamily}} dangerouslySetInnerHTML={createMarkup(desc.slice(0,textLength))}></span> */}
                <Typography
                  className={classes.tp}
                  style={{fontFamily:data?.fontFamily}}
                  textAlign={isRTL === 'ar' ? 'right' : matches ? 'left' : 'center'}
                  dangerouslySetInnerHTML={createMarkup(desc)}></Typography>
                  
                  {/* {!extractedDesc || extractedDesc && extractedDesc.length < textLength ?
                    null :
                    <span className={classes.showBtn}
                      style={{fontFamily:data?.fontFamily,color:buttonFontColor || 'inherit'}}
                      onClick={showLess ? ()=> setShowLess(false) : ()=> setShowLess(true)}
                    >
                      {showLess ? t && t('companyPage.readMore') : t && t('companyPage.showless')}
                    </span>
                  } */}
            </div>
        </Box>
        {image && (
          <Box
            width="auto"
            maxWidth="400px"
            height="auto"
            maxHeight="504px"
            overflow="hidden"
            borderRadius="15px"
            className={classes.aboutImg}
          >
            <ImgLazyLoad>
              <img
                style={{
                  width:"100%",
                  maxWidth: "400px",
                  height:"auto",
                  maxHeight: "504px",
                  borderRadius:"15px",
                  ...(imageDimensions?.height >= 1280 ? {objectFit:'cover'} : {})
                }}
                src={image}
                alt={name || 'about'}
              />
            </ImgLazyLoad>
          </Box>
        )}
      </Box>
    );
};

const ServicesList = ({ categories,data, course }) => {
  const { setPage, count, currentItems } = useMyPagination(categories, 6);
  const displayDescription = data.displayProductDesc !== undefined ? data.displayProductDesc : true;
  const companyId = data.companyData ? data.companyData.companyId : '';

  return (
    <Box bgcolor="#fafafa">
      <Box py={5} width="90%" m="auto">
        <Box display="flex" flexWrap="wrap" justifyContent="flex-start">
          {currentItems?.map((item, i) => {
            if(course) {
              return <CourseCard key={i} service={item} {...{displayDescription,companyId}} />
            }
            else{
              return <ServiceCard key={i} service={item} {...{displayDescription,companyId}} />
            }
          })}
          
        </Box>
        <MyPagination count={count} onChange={setPage} />
      </Box>
    </Box>
  );
};

export default CategoriesList;
